import Vue from 'vue'
import tabbar from './tabbar.vue'

Vue.component(tabbar.name, tabbar)